module.exports = __webpack_public_path__ + "static/media/1.a312a5f2.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/hats/1.png
// module id = 720
// module chunks = 0